import React, {Component} from 'react';
import {console_log} from "../../utils/helper";
class ActivityIndicator extends Component {
    render() {
        let isLoading = this.props.isLoading;
        if(isLoading) {
            document.body.classList.add("scroll-hide");
        }
        else {
            document.body.classList.remove("scroll-hide");
        }
        return (isLoading) ?
            <div className="activity-indicator">
                <div id="loader"></div>
            </div>
            : null;
    }
}

export default ActivityIndicator;


// WEBPACK FOOTER //
// ./src/components/ActivityIndicator/ActivityIndicator.js